export type InventoryTab = "home" | "list" | "supply" | "categories";

const TAB_ROOTS = new Set([
  "/inventory",
  "/inventory/list",
  "/inventory/supply",
  "/inventory/categories",
]);

export const isInventoryTabRoot = (pathname: string): boolean =>
  TAB_ROOTS.has(pathname);

export const resolveInventoryChrome = (
  pathname: string,
): {
  activeTab: InventoryTab;
  showBottomNav: boolean;
} => {
  let activeTab: InventoryTab = "home";

  if (pathname.startsWith("/inventory/list") || pathname === "/inventory/new") {
    activeTab = "list";
  } else if (pathname.startsWith("/inventory/supply")) {
    activeTab = "supply";
  } else if (pathname.startsWith("/inventory/categories")) {
    activeTab = "categories";
  } else if (pathname.startsWith("/inventory/") && pathname !== "/inventory") {
    activeTab = "list";
  }

  return {
    activeTab,
    showBottomNav: isInventoryTabRoot(pathname),
  };
};
